import type { ConnectStripeMutation, ConnectStripeMutationVariables} from 'generated/graphql';
import { useConnectStripeMutation } from 'generated/graphql';
import type { ClientError } from 'graphql-request';
import { graphqlClient } from 'lib/api';
import type { UseMutationOptions } from '@tanstack/react-query';

export default function useConnectStripe(
  options?: UseMutationOptions<ConnectStripeMutation, ClientError, ConnectStripeMutationVariables, unknown>,
) {
  return useConnectStripeMutation<ClientError>(graphqlClient, options);
}
